import Button from "@shared/v2/Button";
import { HandWaveRegularV6, SparklesSolidV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../shared";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";

const NewApplicantActivity = ({ activity, onReadChange }) => {
  const queryParams = new URLSearchParams();
  queryParams.set("tab", "3");

  return (
    <ActivityContainer activity={activity} queryParams={queryParams.toString()} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName="tw-bg-[#ECE6FA] tw-text-[#572BAD]" Icon={HandWaveRegularV6}>
            New Applicant
          </CategoryContainer>
        }
        personName={`${activity.data?.subjectFirstName} ${activity.data?.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <DataField label="Position" data={activity.data.jobName} />
        {activity.data.subjectEmail && <DataField label="Email" data={activity.data.subjectEmail} />}
        {activity.data.subjectPhoneNumber && (
          <DataField label="Phone" data={activity.data.subjectPhoneNumber} />
        )}
        {activity.data.source && <DataField label="Source" data={activity.data.source} />}
      </div>
      <div className={STYLES.btnContainer}>
        {activity.data?.insightsLink && (
          <Button
            schema="secondary"
            className={`${STYLES.btn} tw-w-[105px]`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              window.open(activity.data?.insightsLink, "_blank");
            }}
          >
            <SparklesSolidV6 size="s" />
            <span>VIEW INSIGHT</span>
          </Button>
        )}
        {activity.data?.resumeLink && (
          <Button
            schema="secondary"
            className={`${STYLES.btn} tw-w-[92px]`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              window.open(activity.data?.resumeLink, "_blank");
            }}
          >
            <span>VIEW RESUME</span>
          </Button>
        )}
      </div>
    </ActivityContainer>
  );
};

export default NewApplicantActivity;

NewApplicantActivity.propTypes = {
  ...activityCommonPropTypes,
};

NewApplicantActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
